'use client';

export function getRandomInt(min = 1, max = 99_999_999) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
